import { AxiosInstance } from 'axios';
import { useQuery } from 'react-query';

import { useConfig } from '../app/ConfigurationProvider';
import { useDataProvider } from '../app/DataProvider';
import { EndpointsFactory } from '../constants/integrationConstants';

export const APP_SWITCHER_APPS_ROOT_KEY = 'app-switcher-apps';

export const fetchAppSwitcherApps = (client: AxiosInstance, realm: string) => (): Promise<string[]> =>
  EndpointsFactory.getAppSwitcherApps(client, realm);

export function useAppSwitcherAppsQuery() {
  const { client } = useDataProvider();
  const { tenant } = useConfig();

  return useQuery(APP_SWITCHER_APPS_ROOT_KEY, fetchAppSwitcherApps(client, tenant));
}
